import { Link } from "react-router-dom";

import type { LibrarySortDirection } from "@/core/services/types/library-sort.types";

interface LibrarySortableHeaderProps {
  label: string;
  column: string;
  activeColumn?: string;
  direction: LibrarySortDirection;
  href: string;
  className?: string;
}

function SortIndicator({
  isActive,
  direction,
}: {
  isActive: boolean;
  direction: LibrarySortDirection;
}) {
  if (!isActive) {
    return (
      <svg
        aria-hidden
        viewBox="0 0 12 12"
        className="size-3 text-neutral-300"
        fill="currentColor"
      >
        <path d="M6 2 3.5 5h5L6 2Zm0 8 2.5-3h-5L6 10Z" />
      </svg>
    );
  }

  return (
    <svg
      aria-hidden
      viewBox="0 0 12 12"
      className="size-3 text-whart-text"
      fill="currentColor"
    >
      {direction === "asc" ? (
        <path d="M6 2 3.5 5h5L6 2Z" />
      ) : (
        <path d="M6 10 2.5 7h5L6 10Z" />
      )}
    </svg>
  );
}

export function LibrarySortableHeader({
  label,
  column,
  activeColumn,
  direction,
  href,
  className = "",
}: LibrarySortableHeaderProps) {
  const isActive = activeColumn === column;

  return (
    <th className={className}>
      <Link
        to={href}
        className={`inline-flex items-center gap-1.5 transition-colors hover:text-whart-text ${
          isActive ? "text-whart-text" : ""
        }`}
        aria-sort={
          isActive
            ? direction === "asc"
              ? "ascending"
              : "descending"
            : "none"
        }
      >
        <span>{label}</span>
        <SortIndicator isActive={isActive} direction={direction} />
      </Link>
    </th>
  );
}
